export default __webpack_public_path__ + "static/media/missing_headshot.293c8e8f.jpeg";